import { render } from "./InputText.vue?vue&type=template&id=6c6f4a07"
import script from "./InputText.vue?vue&type=script&lang=ts"
export * from "./InputText.vue?vue&type=script&lang=ts"
script.render = render

export default script